import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FinancialCalculatorService } from '@app/pages/quote/open-quote/services/financial-calculator.service';
import { BaseComponent } from '@app/components/base/base.component';
import { FinancialProductEnum, TaxType } from '../../model/open-quote.model';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { OpenQuoteService } from '@app/pages/quote/open-quote/services/open-quote-service.service';
import { environment } from '@env/environment.local';
import { TranslateService } from '@ngx-translate/core';
import { Constants } from '@app/constants/Constants';
import { ModalService } from '@app/components/modal/modal.service';
import { quoteEnum } from '@components/grace-special-payments/quote-enum.model';
import { interval } from 'rxjs';

// Cambio para merge
@Component({
  template: ""
})
export class InsuranceFormOpenQuoteWrapper  extends BaseComponent
  implements OnInit, OnChanges
{
  @Input() deal: any;
  @Input() nameCompany: any;
  @Input() customer: any;
  @Input() idQuote: any;
  @Input() indexDeal: any;
  @Input() indexInsurance: any;
  @Input() quoteType: quoteEnum;
  @Output() updateInsurance: EventEmitter<any> = new EventEmitter();
  @Output() closeEditionInsurance: EventEmitter<any> = new EventEmitter();
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;

  formInsurance: FormGroup;

  currency: string = 'MXN';

  isLoading: boolean = false;
  quote: any[] = [];
  insuranceDeal: any;
  taxType = TaxType;
  idDeal: number;
  termMax: number = 0;
  collapsed: boolean = true;
  priceWithTax: number = 0;
  priceWithoutTax: number = 0;
  activarBotonJson = environment.downloadJson;

  private readonly translateService = inject(TranslateService);
  private readonly fb = inject(FormBuilder);
  private readonly quoteService = inject(OpenQuoteService);
  private readonly financialCalculator = inject(FinancialCalculatorService);
  private readonly modalService = inject(ModalService);

  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService,
  ) {
    super(route, menu, notification);
  }

  /** Exento IVA: solo se puede elegir "Sí" cuando es SOFOM con crédito directo/directCreditGlobe. En el resto solo "Exento: No". */
  private isTaxFreeSelectVisible(): boolean {
    return (
      this.nameCompany === 'SOFOM' &&
      (this.deal?.financialProductType === FinancialProductEnum.directCredit ||
        this.deal?.financialProductType === FinancialProductEnum.directCreditGlobe)
    );
  }

  /** Criterio igual que cotización de producto: solo mostrar select Exento Sí/No cuando es SOFOM; en el resto solo "Exento: No". */
  get noVatExemptVisible(): boolean {
    return !this.isTaxFreeSelectVisible();
  }

  private getInitialTaxFreeForInsurance(): boolean {
    if (this.noVatExemptVisible) return false;
    const v = this.deal?.taxFree;
    return v === true || v === 'true' || v === 'TRUE';
  }

  private getInitialTaxFreeForInsuranceEdit(): boolean {
    if (this.noVatExemptVisible) return false;
    const v = this.insuranceDeal?.taxFree;
    return v === true || v === 'true' || v === 'TRUE';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['deal']) {
      this.idDeal = this.deal.id;
      this.termMax = this.deal.term;
      this.priceWithTax = this.deal.unitPriceWithTax;
      this.priceWithoutTax = this.deal.unitPriceWithoutTax;
      if (this.deal && this.indexInsurance == -1) {
        this.createFormDeal();
      } else {
        this.insuranceDeal = this.deal.insuranceDeals[this.indexInsurance];
        this.createFormInsurance();
        this.formInsurance.patchValue(this.insuranceDeal);
        this.formInsurance.controls['grace'].setValue(this.deal?.grace);
        this.formInsurance.controls['customerRate'].setValue(this.deal?.customerRate);
        this.formInsurance.controls['currencyType'].setValue(this.deal?.currencyType);
        this.formInsurance.controls['openingFeePercentage'].setValue(this.deal?.openingFeePercentage);

        const financialProductType = this.deal.financialProductType;
        const financialProductChecked = financialProductType == FinancialProductEnum.pureLease ? financialProductType : FinancialProductEnum.directCredit;
        this.formInsurance.controls['financialProductType'].setValue(financialProductChecked);
        // Monto a financiar: usar primero el del seguro (para que coincida con la vista previa), si no tiene usar el del deal padre
        const financialAmountFromDeal =
          this.insuranceDeal?.result?.financialAmount ??
          this.insuranceDeal?.financialAmount ??
          this.deal?.result?.financialAmount ??
          this.deal?.financialAmount;
        if (financialAmountFromDeal != null && financialAmountFromDeal !== '') {
          this.formInsurance.controls['financialAmount'].setValue(financialAmountFromDeal);
        }
        if (this.noVatExemptVisible) {
          this.formInsurance.controls['taxFree'].setValue(false);
        }
      }
    }
    if (changes['nameCompany'] && this.formInsurance && this.noVatExemptVisible) {
      this.formInsurance.controls['taxFree'].setValue(false);
    }
  }

  ngOnInit() {
    // interval(30000).subscribe(()=>{
    //   console.log("Validando FORM");
    //   console.log("Validacion del valor isValid: ", { getRawValue: this.formInsurance.getRawValue() });
    //   for (const key in this.formInsurance.controls) {
    //     const control = this.formInsurance.controls[key];
    //     if (control.invalid) {
    //       console.log(`El campo ${key} tiene el siguiente error:`, control.errors);
    //     }
    //   }
    //   console.log("FIN validacion")
    // });
  }

  createFormDeal() {
    const financialProductType = this.deal.financialProductType;
    const financialProductChecked = financialProductType == FinancialProductEnum.pureLease ? financialProductType : FinancialProductEnum.directCredit;
    this.formInsurance = this.fb.group({
      id: [null, []],
      creationDate: [null, []],
      dealName: ['Seguro ' + this.deal.dealName, [Validators.required]],
      isSelected: [, []],
      roRac: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      currencyType: [this.deal.currencyType, [Validators.required]],
      quoteUsd: [this.deal.quoteUsd, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      tax: [this.deal.tax, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      taxFree: [this.getInitialTaxFreeForInsurance(), []],
      customerRate: [
        this.deal.customerRate,
        [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      ],
      financialProductType: [financialProductChecked, [Validators.required]],
      term: [, [Validators.required]],
      productType: [this.deal.productType, []],
      quantity: [this.deal.quantity, [Validators.required, Validators.pattern(/^[1-9]\d*$/)]],
      brandId: [this.deal.brandId, []],
      subBrandId: [this.deal.subBrandId, []],
      opexSegment: [this.deal.opexSegment, []],
      feature: [this.deal.feature, []],
      classification: [this.deal.classification, []],
      useTime: [this.deal.useTime, []],
      unitPriceWithoutTax: [, [Validators.required, Validators.min(0.01)]],
      unitPriceWithTax: [, [Validators.required, Validators.min(0.01)]],
      totalPriceWithoutTax: [, [Validators.required, Validators.min(0.01)]],
      totalPriceWithTax: [, [Validators.required, Validators.min(0.01)]],
      downPaymentTaxType: ['FIXED_AMOUNT', []],
      downPaymentTax: [0, []],
      downPayment: [0, []],
      financialAmount: [, []],
      openingFeeType: [this.deal.openingFeeType, []],
      openingFee: [this.deal.openingFee, []],
      openingFeePercentage: [this.deal.openingFeePercentage, []],
      balloonType: [this.deal.balloonType, []],
      balloon: [this.deal.balloon, []],
      balloonPercentage: [this.deal.balloonPercentage, []],
      warrantyDeposit: [this.deal.warrantyDeposit, []],
      warrantyDepositPercentage: [this.deal.warrantyDepositPercentage, []],
      warrantyDepositTotal: [
        this.deal.warrantyDepositTotal ? this.deal.warrantyDepositTotal : 0,
        [],
      ],
      warrantyDepositMonth: [
        this.deal.warrantyDepositMonth ? this.deal.warrantyDepositMonth : 0,
        [],
      ],
      subsidyType: [this.deal.subsidyType, []],
      subsidyPercentage: [this.deal.subsidyPercentage, []],
      subsidyTotal: [this.deal.subsidyTotal, []],
      purchaseOptionType: [this.deal.purchaseOptionType, []],
      purchasePercentage: [this.deal.purchasePercentage, []],
      purchaseTotal: [this.deal.purchaseTotal, []],
      residualValueType: [this.deal.residualValueType, []],
      residualValuePercentage: [this.deal.residualValuePercentage, []],
      residualValueTotal: [this.deal.residualValueTotal, []],
      paymentType: [this.deal.paymentType, [Validators.required]],
      confirmationExpensesAmount: [this.deal.confirmationExpensesAmount, []],
      // lifeInsuranceAmount: [this.deal.lifeInsuranceAmount, []],
      lifeInsuranceFactor: [this.deal.lifeInsuranceFactor, []],
      additionalCollateralType: [this.deal.additionalCollateralType, []],
      additionalCollateralPercentage: [
        this.deal.additionalCollateralPercentage,
        [],
      ],
      additionalCollateralTotal: [this.deal.additionalCollateralTotal, []],
      profitDeal: [[], []],
      specialPayments: [[], []],
      payments: [[], []],
      result: [, []],
      insuranceDeals: [, []],
      paymentFormationType: [
        this.deal.paymentFormationType,
        [Validators.required],
      ],
      grace: [this.deal?.grace, []],
      includesInsurance: [this.deal.includesInsurance, []],
    });
    // Monto a financiar del deal (viene en result.financialAmount o en la raíz)
    const financialAmountFromDeal = this.deal?.result?.financialAmount ?? this.deal?.financialAmount;
    if (financialAmountFromDeal != null && financialAmountFromDeal !== '') {
      this.formInsurance.controls['financialAmount'].setValue(financialAmountFromDeal);
    }
  }

  createFormInsurance() {
    this.formInsurance = this.fb.group({
      id: [null, []],
      creationDate: [null, []],
      dealName: [, [Validators.required]],
      isSelected: [, []],
      roRac: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      currencyType: [, [Validators.required]],
      quoteUsd: [, [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      tax: [, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      taxFree: [this.getInitialTaxFreeForInsuranceEdit(), []],
      customerRate: [
        ,
        [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)],
      ],
      financialProductType: ['DIRECT_CREDIT', [Validators.required]],
      term: [, [Validators.required]],
      productType: [, []],
      quantity: [, [Validators.required]],
      brandId: [, []],
      subBrandId: [, []],
      opexSegment: [, []],
      feature: [, []],
      classification: [, []],
      useTime: [, []],
      unitPriceWithoutTax: [, [Validators.required, Validators.min(0.01)]],
      unitPriceWithTax: [, [Validators.required, Validators.min(0.01)]],
      totalPriceWithoutTax: [, [Validators.required, Validators.min(0.01)]],
      totalPriceWithTax: [, [Validators.required, Validators.min(0.01)]],
      downPaymentTaxType: [, []],
      downPaymentTax: [, []],
      downPayment: [, []],
      financialAmount: [, []],
      openingFeeType: [, []],
      openingFee: [, []],
      openingFeePercentage: [, []],
      balloonType: [, []],
      balloon: [, []],
      balloonPercentage: [, []],
      warrantyDeposit: [, []],
      warrantyDepositPercentage: [, []],
      warrantyDepositTotal: [, []],
      warrantyDepositMonth: [, []],
      subsidyType: [, []],
      subsidyPercentage: [, []],
      subsidyTotal: [, []],
      purchaseOptionType: [, []],
      purchasePercentage: [, []],
      purchaseTotal: [, []],
      residualValueType: [, []],
      residualValuePercentage: [, []],
      residualValueTotal: [, []],
      paymentType: [, [Validators.required]],
      paymentFormationType: ['', [Validators.required]],
      confirmationExpensesAmount: [, []],
      // lifeInsuranceAmount: [, []],
      lifeInsuranceFactor: [, [Validators.max(2), Validators.min(0)]],
      additionalCollateralType: [, []],
      additionalCollateralPercentage: [, []],
      additionalCollateralTotal: [, []],
      profitDeal: [[], []],
      specialPayments: [[], []],
      payments: [[], []],
      result: [, []],
      insuranceDeals: [, []],
      gracePeriod: [, []],
      grace: [, []],
      includesInsurance: [this.deal.includesInsurance, []],
    });

    const fieldsRequired = ['dealName', 'term', 'unitPriceWithoutTax', 'tax'];
    fieldsRequired.forEach((field) => {
      this.formInsurance.get(field)?.valueChanges.subscribe((value) => {
        this.formInsurance.controls['result'].setValue(null);
      });
    });
  }

  currencySelected(form: FormGroup) {
    const currency = form.controls['currencyType'].value;
    return this.financialCalculator.currencies.find((i) => i.value == currency)
      ?.type;
  }

  calculateQuote() {
    const idDeal = this.formInsurance.controls['id'].value;
    const payments = this.formInsurance.controls['payments'].value;
    let model = this.financialCalculator.getBodyToCalculateInsurance(
      this.formInsurance,
      this.nameCompany
    );
    const data: any = JSON.parse(JSON.stringify(model));
    Object.keys(data).forEach((key) => {
      if (data[key] !== 0 && !data[key]) {
        delete data[key];
      }
    });

    this.isLoading = true;

    this.quoteService.calculateQuoteOpen(data).subscribe({
      next: (response) => {
        this.isLoading = false;
        //timeout
        if (
          !response.status &&
          response.error ===
            Constants.QUOTE_ERROR_PROCOTIZA_TIME_OUT_INTEGRATION
        ) {
          this.showNotificationError(
            this.translateService.instant(
              Constants.QUOTE_ERROR_PROCOTIZA_TIME_OUT_INTEGRATION
            )
          );
          return;
        } else if (
          !response.status &&
          response.error &&
          response.error.Detalle
        ) {
          this.showNotificationError(response.error.Detalle);
          return;
        } else if (!response.status) {
          this.showNotificationError(
            'Ha ocurrido un error al momento de realizar el calculo. Por favor, intente nuevamente o solicite soporte.'
          );
          return;
        }
        if (payments?.length > 0) {
          this.deletePayments(idDeal, response);
        } else {
          this.assignPayments(response);
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.showNotificationError(
          'Ha ocurrido un error al momento de realizar el calculo.Por favor, intente nuevamente o solicite soporte.'
        );
      },
    });
  }

  assignSpecialPayments(specialPayments: any) {
    this.formInsurance.controls['specialPayments'].setValue(specialPayments);
  }

  setCalculateDiro(profitDeal: any) {
    this.formInsurance.controls['profitDeal'].setValue(profitDeal);
  }

  cancel() {
    this.closeEditionInsurance.emit(true);
  }

  closeModal() {
    this.modalService.closeModal();
    this.modalService.component = null;
  }

  save() {
    const result = this.formInsurance.controls['result'].value;
    if (this.formInsurance.valid) {
      if (result == null) {
        this.showNotificationError('Es necesario calcular para poder guardar.');
      } else {
        const insurance = this.financialCalculator.getBodyforSaveDraft(
          this.formInsurance
        );
        this.updateInsurance.emit(insurance);
        this.closeEditionInsurance.emit(true);
      }
    } else {
      this.showNotificationError(
        'Debe completar los campos requeridos para poder guardar.'
      );
    }
  }

  calculateUnitPriceWithoutTax(form: FormGroup, id: string) {
    let unitPrice = form.controls['unitPriceWithoutTax'].value;
    if (unitPrice > this.priceWithoutTax) {
      this.modalService.component = this.modalTemplate;
      this.modalService.openModal();
    }
    if (!unitPrice) {
      form.controls['unitPriceWithTax'].setValue(unitPrice);
      form.controls['totalPriceWithoutTax'].setValue(unitPrice);
      form.controls['totalPriceWithTax'].setValue(unitPrice);
      form.controls['downPayment'].setValue(unitPrice);
      form.controls['financialAmount'].setValue(unitPrice);
    } else {
      let result = parseFloat(unitPrice);
      const tax = parseInt(form.controls['tax'].value);
      if (unitPrice) {
        form.controls['unitPriceWithTax'].setValue(
          (result + result * (tax / 100)).toFixed(2)
        );
        form.controls['unitPriceWithoutTax'].setValue(result.toFixed(2));
        this.calculateTotal(form);
      }
    }
    this.hideAmountInput(id);
  }

  calculateUnitPriceWithTax(form: FormGroup, id: string) {
    let unitPrice = form.controls['unitPriceWithTax'].value;
    if (unitPrice > this.priceWithTax) {
      this.modalService.component = this.modalTemplate;
      this.modalService.openModal();
    }

    if (!unitPrice) {
      form.controls['unitPriceWithoutTax'].setValue(unitPrice);
      form.controls['totalPriceWithoutTax'].setValue(unitPrice);
      form.controls['totalPriceWithTax'].setValue(unitPrice);
      form.controls['downPayment'].setValue(unitPrice);
      form.controls['financialAmount'].setValue(unitPrice);
    } else {
      let result = parseFloat(unitPrice);
      const tax = parseInt(form.controls['tax'].value);
      form.controls['unitPriceWithoutTax'].setValue(
        ((result / (100 + tax)) * 100).toFixed(2)
      );
      form.controls['unitPriceWithTax'].setValue(result.toFixed(2));
      this.calculateTotal(form);
    }
    this.hideAmountInput(id);
  }

  calculateTotal(form: FormGroup) {
    const unitsQuantity = form.controls['quantity'].value;

    if (!form.controls['unitPriceWithTax'].value) return;
    const priceWithTax = this.unformatInputValue(
      form.controls['unitPriceWithTax'].value
    );
    const priceWithoutTax = this.unformatInputValue(
      form.controls['unitPriceWithoutTax'].value
    );

    if (!unitsQuantity) return;
    form.controls['totalPriceWithoutTax'].setValue(
      priceWithoutTax * unitsQuantity
    );
    form.controls['totalPriceWithTax'].setValue(priceWithTax * unitsQuantity);

    this.calculateFinacialAmount(form);
  }

  calculateFinacialAmount(form: FormGroup) {
    form.controls['financialAmount'].setValue(
      form.controls['totalPriceWithTax'].value
    );
  }

  calculateCommissionForOpening(form: FormGroup, id: string) {
    // form.controls['openingFee'].setValue(
    //   this.financialCalculator.calculateCommissionForOpening(form)
    // );
    this.hideAmountInput(id);
  }

  status() {
    const form = this.formInsurance;
    for (const controlName of Object.keys(form.controls)) {
      const control = form.get(controlName);

      if (control && control.invalid) {
      }
    }
  }

  deletePayments(idInsurance: number, result: any) {
    this.isLoading = true;
    this.quoteService
      .deletePaymentsInsurance(this.idQuote, this.idDeal, idInsurance)
      .subscribe({
        next: (response) => {
          this.assignPayments(result);
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
        },
      });
  }

  assignPayments(result: any) {
    this.formInsurance.controls['payments'].setValue(result.data[0].payments);
    this.quote = result.data;
    this.formInsurance.controls['result'].setValue({
      id: this.quote[0].id,
      creationDate: this.quote[0].creationDate,
      term: this.quote[0].term,
      unitPrice: this.quote[0].unitPrice,
      unitPriceNoTax: this.quote[0].unitPriceNoTax,
      annualPercentageRate: this.quote[0].annualPercentageRate,
      downpaymentAmount: this.quote[0].downpaymentAmount,
      openingfeeAmount: this.quote[0].openingfeeAmount,
      guaranteeDepositAmount: this.quote[0].guaranteeDepositAmount,
      insuranceAmount: this.quote[0].insuranceAmount,
      additionalServicesAmount: this.quote[0].additionalServicesAmount,
      confirmationExpensesAmount: this.quote[0].confirmationExpensesAmount,
      initialPayment: this.quote[0].initialPayment,
      financialAmount: this.quote[0].financialAmount,
      monthlyPayment: this.quote[0].monthlyPayment,
      annualTotalCost: this.quote[0].annualTotalCost,
    });
    this.formInsurance.controls['financialAmount'].setValue(this.quote[0].financialAmount);
    const insurance = this.financialCalculator.getBodyforSaveDraft(
      this.formInsurance
    ) as any;
    // if (this.formInsurance.controls['gracePeriod'].value) {
    //   insurance["gracePeriod"] = this.formInsurance.controls['gracePeriod'].value;
    // }
    this.updateInsurance.emit(insurance);
    this.isLoading = false;
  }

  onChange() {
    const term = this.formInsurance.controls['term'].value;
    if (!term) return;
    if (term > this.termMax) this.formInsurance.controls['term'].setValue(null);
  }

  collapse() {
    this.collapsed = !this.collapsed;
    const element = document.getElementById(
      'contract-edition'
    ) as HTMLInputElement;
    if (element.classList.contains('collapsed')) {
      element.classList.remove('collapsed');
    } else {
      element.classList.add('collapsed');
    }
  }

  downloadJsonProcotiza() {
    const dataForDownload =
      this.financialCalculator.getBodyToCalculateInsurance(
        this.formInsurance,
        this.nameCompany
      );

    this.quoteService.calculateQuoteOpenJson(dataForDownload).subscribe(
      (response) => {
        if (response.status === true) {
          const jsonStr = JSON.stringify(response.data, null, 2);

          const cotizacionFileName = this.idDeal
            ? `PropuestaSeguro(${this.idDeal}).json`
            : 'PropuestaSeguro.json';

          const blob = new Blob([jsonStr], { type: 'application/json' });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = cotizacionFileName;
          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
        }
      },
      (error) => {}
    );
  }
}
